import React, {Component} from 'react';
import Close from './../../images/ic_closing_cross.svg';
import styles from './Infobox.scss';

class Infobox extends Component {
	constructor (props) {
		super(props);

		this.state = {
			visible: props.infoOpen
		}

		this.close = this.close.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			visible: true
		})

	}

	close() {
		this.setState({
			visible: false
		})
	}

	render() {
		if (this.state.visible === false) return null;

		return (
			<div className="Infobox" style={{backgroundColor:this.props.info.color}}>
				{this.props.info.type &&
				<div>
					<div className="shadow" />
	 				<img className="icon" src={'/images/components/'+this.props.info.type+'.svg'}/>
 				</div>
 				}
				<p style={HeadlineStyle}>
					{this.props.info.title}
				</p>
				<hr style={HrStyle} />
				<p style={TextStyle}>
					{this.props.info.description}
				</p>
				<Close width='40px' height='40px' onClick={this.close} style={CloseStyle} />
			</div>	
		)
	}
}

const CloseStyle = {
	cursor: 'pointer',
	position: 'absolute',
	right: 40,
	top: 40,	
	WebkitTapHighlightColor: 'rgba(0,0,0,0)'
}

const HrStyle = {
	border: 0,
	backgroundColor: 'black',
	height: '5px'
}

const HeadlineStyle = {
	font: 'normal normal normal 40px Arial, Helvetica, sans-serif',
}

const TextStyle = {
	font: 'normal normal normal 30px Arial, Helvetica, sans-serif',
	overflow: 'auto'
}

Infobox.defaultProps = {
	unit: null
}

export default Infobox;


// WEBPACK FOOTER //
// ./src/components/Infobox/index.jsx